module.exports = __webpack_public_path__ + "media/images/club-logo/4-a33f35adccd1f30613675cd0f2a683d2.png";